import { createContext } from 'react';

export type AuthProviderContextType = {
  type: 'detached' | 'default';
  providerType: 'google' | 'figma' | null;
  setProviderType: (provider: 'google' | 'figma' | null) => void;
  setFormType: (form: 'login' | 'register') => void;
};

export const AuthProviderContext = createContext<AuthProviderContextType>({
  type: 'default',
  providerType: null,
  setProviderType: (provider: 'google' | 'figma' | null) => null,
  setFormType: (form: 'login' | 'register') => null,
});
